import { now } from "lodash";
import Swal from "sweetalert2";


/**
 * 
 * @param alertMsg recibe un string con el mensaje que saldra en el popup 
 * @param error debe pasarse la respuesta de error que se guardara en el log
 * @param form Opcional, recibe el form que se envia en la peticion para guardarlo en el log 
 */
export function LOG(alertMsg: string, error: any, form?: any) {
    Swal.fire({
        icon: 'error',
        title: alertMsg,
        text: error.message,
        showConfirmButton: false,
        footer: '<button id="showLogsButton" class="btn btn-primary p-2 ">Descargar Logs</button>', // Agregar botón de logs en el footer
    });
    // Agregar evento click al botón de logs
    document.getElementById('showLogsButton').addEventListener('click', () => {
        if (form) {
            crearArchivoTXT(error, ('log_error_' + Date.now() + '.txt'), form)
        }
        else {
            crearArchivoTXT(error, ('log_error_' + Date.now() + '.txt'))
        }
        // Aquí puedes agregar el código para mostrar los logs o redirigir a la página de logs.

    });
}

function crearArchivoTXT(error: any, nombreArchivo: string, form?: any) {
    let contenidoArchivo
    if (form) {
        contenidoArchivo = `
        {Fecha: "${new Date().toISOString()}",\nMensaje de error: ${JSON.stringify(error)}\n\n,Data enviada: ${JSON.stringify(form)}}`;
    }
    else {
        contenidoArchivo = `{Fecha: "${new Date().toISOString()}",\nMensaje de error: ${JSON.stringify(error)}\n\n}`;
    }

    // Crea un objeto Blob con el contenido del archivo
    const blob = new Blob([contenidoArchivo], { type: 'text/plain' });

    // Crea un enlace para descargar el archivo
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombreArchivo);

    // Simula un clic en el enlace para iniciar la descarga
    document.body.appendChild(link);
    link.click();

    // Limpia el objeto URL y elimina el enlace creado
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
}

